import { api } from "@/lib/api";

const KEY = "ss_offline_attempts";
const listeners = new Set();

export const readQueue = () => { try { return JSON.parse(localStorage.getItem(KEY) || "[]"); } catch { return []; } };
const write = (q) => { localStorage.setItem(KEY, JSON.stringify(q)); listeners.forEach((fn) => fn(q)); };
export const subscribe = (fn) => { listeners.add(fn); return () => listeners.delete(fn); };

export const isNetworkError = (e) => !e?.response || e.code === "ERR_NETWORK";

const fileToDataUrl = (file) => new Promise((res, rej) => { const r = new FileReader(); r.onload = () => res(r.result); r.onerror = rej; r.readAsDataURL(file); });

export async function enqueueAttempt({ job, body, pendingFiles }) {
  const photos = [];
  for (const f of pendingFiles) {
    if (f.size > 3 * 1024 * 1024) continue;
    photos.push({ name: f.name, type: f.type, dataUrl: await fileToDataUrl(f) });
  }
  const q = readQueue();
  q.push({ id: `q_${Date.now()}_${Math.random().toString(36).slice(2, 7)}`, job_id: job.id, job_number: job.job_number, recipient_name: job.recipient_name, body, photos, queued_at: new Date().toISOString() });
  try { write(q); } catch { throw new Error("Offline storage is full — remove photos and try again"); }
  return { skippedPhotos: pendingFiles.length - photos.length };
}

const dataUrlToBlob = async (dataUrl) => (await fetch(dataUrl)).blob();

export async function syncQueue() {
  const q = readQueue();
  if (!q.length || !navigator.onLine) return { synced: 0, remaining: q.length };
  let synced = 0;
  for (const item of [...q]) {
    try {
      const uploaded = [...(item.body.photos || [])];
      for (const p of item.photos) {
        const fd = new FormData();
        fd.append("file", await dataUrlToBlob(p.dataUrl), p.name);
        fd.append("stamp_time", item.body.attempted_at);
        if (item.body.gps_lat) { fd.append("lat", item.body.gps_lat); fd.append("lng", item.body.gps_lng); }
        fd.append("label", `Job ${item.job_number} · ${item.recipient_name} (synced from offline)`);
        const { data } = await api.post("/uploads", fd);
        uploaded.push({ id: data.id, url: data.url, filename: data.filename });
      }
      await api.post("/attempts", { job_id: item.job_id, ...item.body, photos: uploaded, notes: `${item.body.notes || ""}${item.body.notes ? "\n" : ""}[Logged offline at ${new Date(item.queued_at).toLocaleString()}]` });
      write(readQueue().filter((x) => x.id !== item.id));
      synced += 1;
    } catch (e) {
      if (isNetworkError(e)) break;
      write(readQueue().filter((x) => x.id !== item.id));
    }
  }
  return { synced, remaining: readQueue().length };
}
